import { SimpleRope } from "@pixi/mesh-extras";
SimpleRope.prototype._renderCanvas = function(renderer) {
  (this.autoUpdate || this.geometry._width !== this.shader.texture.height) && (this.geometry._width = this.shader.texture.height, this.geometry.update()), this.shader.update && this.shader.update(), this.calculateUvs(), this.material._renderCanvas(renderer, this);
};
//# sourceMappingURL=SimpleRope.mjs.map
